import { useCallback } from 'react';
import type { ProductListItem } from 'types/capi/shared';

import ProductCardImpressionEvent, {
  type ProductCardImpressionDisplayType
} from '~/events/ProductCardImpressionEvent';
import useImpression from '~/hooks/useImpression';
import useUser from '~/hooks/useUser';

type Options = {
  displayType?: ProductCardImpressionDisplayType;
  // Off when the card cannot yet satisfy the contract (a search hit with no variant to read stock
  // from): an impression missing a required field quarantines at the lake, so it is not sent.
  enabled?: boolean;
  isBot: boolean;
  modulePosition?: number;
  moduleType?: string;
  position?: number;
  product: Pick<ProductListItem, 'id' | 'price' | 'stock_status'>;
};

function useProductCardImpression<T extends HTMLElement = HTMLDivElement>({
  displayType,
  enabled = true,
  isBot,
  modulePosition,
  moduleType,
  position,
  product
}: Options) {
  const { guestId } = useUser();

  const track = useCallback(() => {
    new ProductCardImpressionEvent({
      displayType,
      guestId,
      isBot,
      modulePosition,
      moduleType,
      position,
      product
    }).track();
  }, [
    displayType,
    guestId,
    isBot,
    modulePosition,
    moduleType,
    position,
    product
  ]);

  return useImpression<T>(track, { enabled: enabled && !isBot });
}

export default useProductCardImpression;
